// extracted by mini-css-extract-plugin
export default {"tableContainer":"Bwqxc","select":"UeEeh","portal":"TVa57"};